import { Container } from "../atoms/Container";
import { Eyebrow } from "../atoms/Eyebrow";
import { HairlineRule } from "../atoms/HairlineRule";
import { WaitlistEmailField } from "../atoms/WaitlistEmailField";

type SiteHeroProps = {
  mobile?: boolean;
};

export function SiteHero({ mobile = false }: SiteHeroProps) {
  const pad = mobile ? 24 : 96;
  return (
    <section
      id="top"
      style={{
        paddingTop: mobile ? 56 : 128,
        paddingBottom: mobile ? 56 : 128,
      }}
    >
      <Container pad={pad}>
        <Eyebrow style={{ marginBottom: mobile ? 28 : 40 }}>
          My First Marathon · An app by Speed AI
        </Eyebrow>

        <h1
          style={{
            fontFamily: "var(--display)",
            fontSize: mobile ? "clamp(48px, 13vw, 64px)" : "var(--t-hero)",
            lineHeight: 0.94,
            letterSpacing: "-0.035em",
            fontWeight: 400,
            color: "var(--text)",
            margin: 0,
          }}
        >
          You&apos;re going to
          <br />
          run a marathon.
        </h1>

        <div
          style={{
            marginTop: mobile ? 28 : 44,
            display: "grid",
            gridTemplateColumns: mobile ? "1fr" : "minmax(0,1fr) minmax(0,1fr)",
            gap: mobile ? 28 : 64,
            alignItems: "start",
          }}
        >
          <div
            style={{
              fontFamily: "var(--ui)",
              fontSize: mobile ? 17 : 19,
              lineHeight: 1.55,
              color: "var(--text)",
              maxWidth: 480,
              letterSpacing: "-0.005em",
            }}
          >
            Not today. Not next week. But on a date you&apos;ll circle on the calendar, you&apos;ll
            run twenty-six miles — and we&apos;re going to get you there.
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: mobile ? 28 : 36 }}>
            <div
              style={{
                fontFamily: "var(--display)",
                fontSize: mobile ? 30 : 36,
                lineHeight: 1.05,
                color: "var(--accent)",
                letterSpacing: "-0.02em",
              }}
            >
              You&apos;ll finish.
            </div>

            <div id="join">
              <WaitlistEmailField size={mobile ? "sm" : "lg"} source="hero" />
            </div>
          </div>
        </div>
      </Container>

      <div style={{ marginTop: mobile ? 56 : 96, padding: `0 ${pad}px` }}>
        <Container pad={0}>
          <HairlineRule />
        </Container>
      </div>
    </section>
  );
}
